'use client';

import PersonIcon from '@mui/icons-material/Person';
import { Box } from '@mui/material';

import type { SearchProfile } from '@/types';
import { SearchProfileCard } from '../Page/SearchProfileCard';
import { SearchSectionHeader } from './SearchSectionHeader';

interface SearchProfileResultsProps {
  profiles: SearchProfile[];
  onProfileClick: (profile: SearchProfile) => void;
}

export const SearchProfileResults = ({ profiles, onProfileClick }: SearchProfileResultsProps) => {
  const renderProfile = (profile: SearchProfile) => (
    <SearchProfileCard
      key={profile.proxyWallet}
      profile={profile}
      onClick={onProfileClick}
      variant="dropdown"
    />
  );

  const renderProfilesList = profiles?.map(renderProfile);

  return (
    <Box sx={{ mb: 1 }}>
      <SearchSectionHeader title="Profiles" icon={PersonIcon} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>{renderProfilesList}</Box>
    </Box>
  );
};
